import WINDOW from "../../../../utils/window";
import getAxisValue from "./get-axis-value";
import getPointerParallaxPercents from "./get-pointer-parallax-percents";

/**
 *
 * @param {MainClassProps} _main
 * @param {TriggerProps} trigger
 * @returns
 */
const getPointerParallax = (_main, trigger) => {
  const axis = getAxisValue(trigger);

  const width = /** @type {Number} */ (WINDOW.get("width"));
  const height = /** @type {Number} */ (WINDOW.get("height"));
  const pointer = /** @type {WindowCoordinatesProps} */ (WINDOW.get("pointer"));

  switch (axis) {
    case "x":
      return getPointerParallaxPercents(pointer, width, "x");

    case "y":
      return getPointerParallaxPercents(pointer, height, "y");

    default: {
      const x = getPointerParallaxPercents(pointer, width, "x");
      const y = getPointerParallaxPercents(pointer, height, "y");

      return (x + y) / 2;
    }
  }
};

export default getPointerParallax;
